<template>
	<section class="view-ui-callout-icon">
		<section class="text-center padded">
			<slot name="icon">
				<img class="filter-invert push-bottom" v-bind:src="iconUrl" width="40" />
			</slot>

			<slot name="text">
				<p v-html="message"></p>
			</slot>

			<slot></slot>
		</section>
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, mounted } from '@/Utility/Decorators';
	import { assetRef } from '@/Manager/Asset';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Ui/Callout
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewUiCalloutIcon extends ViewBase {
		/**
		 * @type string
		 */
		public get iconUrl(): string {
			return assetRef('@chalkysticks/sass/build/asset/image/icon/' + this.iconFilename);
		}

		/**
		 * @type string
		 */
		@Prop()
		public iconFilename!: string;

		/**
		 * @type string
		 */
		@Prop()
		public message!: string;
	}
</script>

<style lang="scss">
	.view-ui-callout-icon {
		align-items: center;
		aspect-ratio: 4 / 3;
		background-color: var(--chalky-blue);
		border-radius: var(--border-radius);
		display: flex;
		height: 100%;
		justify-content: center;
		margin: 0 1rem 1rem 1rem;
		opacity: 0.75;
	}

	.full-panel:has(.view-ui-callout-icon) {
		height: 100%;
		padding: 1rem;
	}
</style>
